import {useEffect} from 'react';

/**
 * Custom hook to inject CSS styles into document head for HTML view mode
 * @param {string} viewMode - Current view mode ('text' or 'html')
 * @param {string} cssStyles - CSS styles to inject
 * @param {string} docId - Document ID (used for unique style element ID)
 */
export function useCssStylesInjection(viewMode, cssStyles, docId) {
    useEffect(() => {
        if (viewMode === 'html' && cssStyles && docId) {
            const styleId = `document-styles-${docId}`;
            let styleElement = document.getElementById(styleId);

            if (!styleElement) {
                styleElement = document.createElement('style');
                styleElement.id = styleId;
                styleElement.textContent = cssStyles;
                document.head.appendChild(styleElement);
            }

            return () => {
                const el = document.getElementById(styleId);
                if (el) el.remove();
            };
        }
    }, [viewMode, cssStyles, docId]);
}
